import type { AnalyticsCachedSettings } from 'owa-analytics-types';

let analyticsCachedSettings: AnalyticsCachedSettings | null = null;

export function getCachedSettings(): AnalyticsCachedSettings | null {
    return analyticsCachedSettings;
}

export function setCachedSettings(settings: AnalyticsCachedSettings): void {
    analyticsCachedSettings = settings;
}

export function updatePartialCachedSettings(
    partialSettings: Partial<AnalyticsCachedSettings>
): void {
    analyticsCachedSettings = {
        ...analyticsCachedSettings,
        ...partialSettings,
    } as AnalyticsCachedSettings;
}
